import React from "react";
import { Modal, Box, Dialog } from "@mui/material";
import {
  AccordionSummary,
  AccordionDetails,
  Accordion,
  LinearProgress,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { current } from "immer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import config from "../../../config/aws-exports";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DialogContent from "@mui/material/DialogContent";
import { useSelector, useDispatch } from "react-redux";
import { authData } from "../../../redux/auth/authSlice";
import Downloadcsv from "./Downloadcsv";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    width: "100%",
    paddingTop: "20px",
  },
  root1: {
    width: "100%",
  },
  programtitle: {
    fontSize: "18px",
    color: config.main_color_1,
  },
  heading: {
    fontSize: "18px",
    fontWeight: 400,
    color: config.main_color_1,
  },
  coursetitle: {
    fontSize: "16px",
    fontWeight: 400,
    color: config.main_color_2,
  },
  modulename: {
    fontSize: "14px",
    fontWeight: 400,
    color: "black",
    width: "60%",
  },
  subheading: {
    color: "black",
    fontFamily: "nunito",
    fontSize: "14px",
    fontWeight: "600px",
  },
  "MuiAccordionDetails-root": {
    display: "inline-block",
    width: "100%",
    padding: "10px 20px",
  },
}));
export default function MiniAssignPopUp(props) {
  const classes = useStyles();
  const theme = useTheme();
  let userDetails = useSelector(authData);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    props.setMinOpen(false);
  };
  let arrHeader = ["otitle", "grade"];
  let newHeaders = ["title", "Score"];
  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            color="primary"
            style={{ backgroundColor: "whitesmoke" }}
            {...props}
          />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  return (
    <>
      {props.minOpen && (
        <Dialog
          fullScreen={fullScreen}
          open={props.minOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <div>
            <div style={{display:"flex",justifyContent:"end",margin:"-5px -20px 10px 0px"}}>
              <button
                onClick={handleClose}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  float:'right',
                }}
              >
                <CloseIcon fontSize="large" />
              </button>
             </div>
             <div style={{display:'flex'}}>
             <h3 style={{width:'375px',paddingBottom:'10px'}}>Mini Assignments Score - {props.uname}</h3>
                <Downloadcsv maindata={props.minAssignData} arrHeader={arrHeader} 
          newHeaders={newHeaders} filename={"MiniAssign"} />  
             </div>
             
       
              <div className="leftaccordionholder">
             
                <table>
                  <tr>
                    <th
                      style={{
                        minWidth: "250px",
                        backgroundColor: "#0f80a4",
                        color: "#fff",
                        fontSize: "16px",
                        padding: "1rem",
                      }}
                    ></th>
                    <th
                      style={{
                        minWidth: "150px",
                        backgroundColor: "#0f80a4",
                        color: "#fff",
                        fontSize: "16px",
                        padding: "1rem",
                        display: "grid",
                        placeItems: "center",
                      }}
                    >
                      Score
                    </th>
                  </tr>

                  {props.minAssignData.map((value, i) => (
                    <>
                      {value.objects.map((mini, i) => {
                        return (
                          <>
                            {mini.grade !== undefined && (
                              <>
                                {mini.grade !== -1 && (
                                  <tr
                                    style={{ borderBottom: "1px solid #fff" }}
                                  >
                                    <td
                                      style={{
                                        minWidth: "250px",
                                        backgroundColor: "#0f80a4",
                                        color: "#fff",
                                        fontSize: "16px",
                                        padding: "1rem",
                                      }}
                                    >
                                      {mini.otitle}
                                    </td>

                                    <td
                                      style={{
                                        fontSize: "16px",
                                        padding: "1rem",
                                        display: "grid",
                                        placeItems: "center",
                                      }}
                                    >
                                      {mini.grade} / 10
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                          </>
                        );
                      })}
                    </>
                  ))}
                </table>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
